// Third-party
import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

// Utils
import { formatMessage } from '../../../utils/i18n';

// Components
import { FolderTabs } from '../../components/navigation';
import SecurityPassword from './SecurityPassword';
import SecurityTwoFactor from './SecurityTwoFactor';
import User from '@/types/user';
import NavigationItem from '@/types/navigation-item';

type Props = {
  user: User;
  onUpdatePassword: (current: string, password: string, confirm: string) => Promise<void>;
};

const LegacySettingsSecurityTabs = ({ onUpdatePassword, user }: Props) => {
  const getNavigationTabs = (): NavigationItem[] => [
    {
      label: formatMessage('Settings.Security.Password.Tab'),
      value: '/settings/security/password',
    },
    {
      label: formatMessage('Settings.Security.TwoFactor.Tab'),
      value: '/settings/security/two-factor',
    },
  ];

  return (
    <div className="settings-enterprise settings-security settings-tab">
      <FolderTabs items={getNavigationTabs()} />

      <div className="tab-content">
        <Switch>
          <Route path="/settings/security/password">
            <SecurityPassword onSave={onUpdatePassword} />
          </Route>

          <Route path="/settings/security/two-factor">
            <SecurityTwoFactor user={user} />
          </Route>

          <Redirect to="/settings/security/password" />
        </Switch>
      </div>
    </div>
  );
};

export default LegacySettingsSecurityTabs;
